var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('h2',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.subtitle)?_c('p',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }